<template>
  <div>
    <div class="panel">
      <div class="filter">
        <el-form
          :inline="true"
          @submit.native.prevent
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="80px"
          class="oneline"
          size="small"
        >
          <el-form-item label="库存基地">
            <BaseSelect v-model="filter.base_id" :clearable="true"></BaseSelect>
          </el-form-item>
          <el-form-item label="钻井" v-if="category == 2">
            <DrillWellSelect
              v-model="filter.drill_well_id"
              :clearable="true"
            ></DrillWellSelect>
          </el-form-item>
          <el-form-item label="配件分类">
            <ItemTemplateMultipleSelect
              style="width: 300px"
              v-model="filter.item_template_ids"
              :category="category"
              :collapseTags="true"
            ></ItemTemplateMultipleSelect>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="panel">
      <div style="display: flex; justify-content: end">
        <file-button
          obj="item_inventory"
          :filter="queryData"
          :importButton="false"
        ></file-button>
      </div>
      <InventoryTable
        :items="items.list"
        :category="category"
        v-loading="loading"
      ></InventoryTable>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData"
        layout="total, prev, pager, next"
        :total="items.count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { itemInventoryList } from '@/service/getData'
import InventoryTable from './table'
import ItemTemplateMultipleSelect from '@/components/select/item_template_multiple_select'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    InventoryTable,
    ItemTemplateMultipleSelect,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      if (data.item_template_ids.length > 0) {
        data.item_template_ids = data.item_template_ids.join(
          '&item_template_ids='
        )
      } else {
        delete data.item_template_ids
      }
      data.category = this.category
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        item_template_ids: [],
        base_id: 0,
        drill_well_id: 0,
        page: 1,
        size: 10,
      },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    reset() {
      this.$refs['filterForm'].resetFields()
      this.filter.page = 1
      this.filter.item_template_ids = []
      this.filter.base_id = 0
      this.filter.drill_well_id = 0
      this.getData()
    },
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      this.loading = true
      let res = await itemInventoryList(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
  },
}
</script>